<div class="back">
    <div class="back-image" [style.background-image]="'url(/assets/login/' + img + ')'"></div>

    <div class="container flex flex-column justify-content-center align-items-center">
        <p-card class="shadow" header="Esqueceu sua senha?">
            <ng-template pTemplate="header">
                <app-logo [paramChave]="true" [loadingEmpresa]="false"></app-logo>
            </ng-template>

            <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2 pt-2">
                <div class="field">
                    <div class="card flex flex-wrap justify-content-center gap-3">
                        <span class="p-input-icon-left">
                            <i class="pi pi-envelope"></i>
                            <input type="text" placeholder="Usuário" pInputText [(ngModel)]="usuario" />
                        </span>
                    </div>
                </div>
            </div>
            <ng-template pTemplate="footer pt-5">
                <div class="flex flex-column align-items-center justify-content-center font-bold border-round m-2">
                    <div class="field">
                        <p-button class="btn-bg-primary" label="Redefinir senha" (click)="redefinirSenha()" [loading]="loading" [disabled]="!usuario"></p-button>
                    </div>

                    <p class="color-success text-center" *ngIf="sucesso">Sua nova senha foi enviada. Verifique seu email</p>
                    <p class="color-error text-center" *ngIf="error">Não foi possível redefinir sua senha. Tenta novamente mais tarde</p>
                    <p class="color-error text-center" *ngIf="invalid">Usuário inválido</p>

                    <div class="field">
                        <a (click)="voltarLogin()">Voltar para login</a>
                    </div>
                </div>
            </ng-template>
        </p-card>
    </div>
</div>